export const LOCALE_OPTIONS = [
    { value: 'ko', text: '한국어 (ko)' },
    { value: 'en', text: '영어 (en)' },
    { value: 'ca', text: '중국어 (ca)' },
]

// 조건(컨텍스트) 빌더에서 선택 가능한 키 정의. entity = 값 검색에 쓰는 GET /mail/lookup/<entity>
export const CONTEXT_KEYS = [
    // 라벨에 'ID' 를 붙이지 않는다 — 입력은 검색해서 고르고, 표시도 이름이라 ID 는 괄호 안 보조 정보다.
    { value: 'campaign', label: '캠페인', entity: 'campaign' },
    { value: 'project', label: '프로젝트 코드', entity: 'project' },  // 매칭 값은 ge_project_codes.project_code 문자열
    { value: 'company', label: '기업', entity: 'company' },
    { value: 'user', label: '사용자', entity: 'user' },
    { value: 'sub_domain', label: '서브도메인', entity: 'brand' },
]

// 발송 메일에 사용하지 않는 시스템/보안 필드 (변수 헬퍼·드롭다운에서 숨김)
// 형식: 'group.field'
export const HIDDEN_VARIABLE_FIELDS = new Set([
    'user.password',
    'user.api_key',
    'user.refresh_token',
    'user.refresh_token_version',
    'user.failed_login_attempts',
    'user.account_locked_until',
    'user.is_admin',
    'user.authenticated',
    'user.last_login_at',
    'user.created_at',
    'user.department_id',
])

// 시나리오 드롭다운 고정 표시 순서 (평가 라이프사이클 흐름 기준).
// /mail/scenario 응답은 code 알파벳순이라 업무 흐름과 무관해서, 여기서 순서를 고정한다.
// 이 배열에 없는 코드는 뒤에 code 알파벳순으로 배치.
export const SCENARIO_ORDER = [
    // 1) 초대·신청·승인
    'invite',
    'asmt-reg',
    'asmt-reg-manager',
    'req-approval',
    'asmt-reg-admin-noti',
    'reg-appr',
    'reg-deny',
    're-req',
    // 2) 제출
    'submit-noti',
    'submit-admin-noti',
    'forced-submit-noti',
    'forced-submit-admin-noti',
    // 3) 보완요청
    'supplement-req',
    // 4) 완료·개선계획
    'asmt-comp',
    'actionplan-guide',
    'actionplan-submit',
    // 5) 계정·시스템
    'find_pw',
    'password-reset-link',
    'login',
]

// scenarios 배열을 SCENARIO_ORDER 순서로 정렬 (없는 코드는 뒤에 알파벳순)
export function sortScenarios(scenarios) {
    const rank = (code) => {
        const i = SCENARIO_ORDER.indexOf(code)
        return i === -1 ? SCENARIO_ORDER.length : i
    }
    return [...(scenarios || [])].sort((a, b) => {
        const ra = rank(a.code)
        const rb = rank(b.code)
        if (ra !== rb) return ra - rb
        return String(a.code).localeCompare(String(b.code))
    })
}
